function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import React, { Component } from "react";
import { connect } from "react-redux";
import { openModal } from "@common/actions";
import { COOKIE_POLICY } from "@config/constants";
var CookieBanner = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(CookieBanner, Component);
    var _super = _create_super(CookieBanner);
    function CookieBanner(props) {
        _class_call_check(this, CookieBanner);
        var _this;
        _this = _super.call(this, props);
        _this.agree = _this.agree.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(CookieBanner, [
        {
            key: "agree",
            value: function agree() {
                var email = this.props.userDetails.email;
                localStorage.setItem("".concat(email, "-cookieConsent"), true);
                this.props.closeCookieBanner();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, i18n = _this_props.i18n, _$openModal = _this_props.openModal;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "cookie-banner-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "icon-clear-wrapper",
                            children: /*#__PURE__*/ _jsx("span", {
                                onClick: this.agree,
                                className: "icon icon-clear pointer"
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "message-wrapper d-inline-block",
                            children: /*#__PURE__*/ _jsx("p", {
                                children: i18n.cookieConsent
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "buttons-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsxs(Button, {
                                        classes: {
                                            label: "ux-button-label"
                                        },
                                        onClick: this.agree,
                                        className: "button agree raised pointer",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "icon icon-done"
                                            }),
                                            i18n.iAgree
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        classes: {
                                            label: "ux-button-label"
                                        },
                                        onClick: function() {
                                            return _$openModal(COOKIE_POLICY, {
                                                title: i18n.cookiePolicy.title,
                                                text: i18n.cookiePolicy.text
                                            });
                                        },
                                        className: "cookie-policy raised pointer",
                                        children: i18n.cookiePolicy.title
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return CookieBanner;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, userDetails = param.userDetails, _$openModal = param.openModal;
    return {
        i18n: i18n,
        userDetails: userDetails,
        openModal: _$openModal
    };
};
export default connect(mapStateToProps, {
    openModal: openModal
})(CookieBanner);
